if (typeof window !== 'undefined') {
  window['dataLayer'] = window['dataLayer'] || [];
}

export const track = (event: string, contents: object) => {
  const entry = { ...contents, event };
  if (typeof window !== 'undefined') {
    window['dataLayer']?.push(entry);
  }
};
